import { Skeleton } from '@packages/shared';

export const RecoBrandCardSkeleton = () => (
  <Skeleton variant="rectangular" height={130} width="100%" />
);
